import React from "react";
import { ACCREDITATIONS } from "../../data/content";

// Marquee strip: duplicated content for seamless scroll
export default function AccreditationsStrip() {
  const items = [...ACCREDITATIONS, ...ACCREDITATIONS];
  return (
    <section className="bg-[#F8FAFC] border-y border-slate-200 py-10 overflow-hidden" data-testid="accreditations-strip">
      <p className="text-[10px] uppercase tracking-[0.3em] text-slate-500 text-center mb-6">Accredited · Audited · Assured</p>
      <div className="relative">
        <div className="marquee-track flex gap-12 whitespace-nowrap w-[200%]">
          {items.map((a, i) => (
            <div key={i} className="flex items-center gap-3 px-6 py-2 border border-slate-300 bg-white">
              <span className="font-display font-bold text-slate-900 tracking-tight">{a.name}</span>
              <span className="text-xs text-slate-500 uppercase tracking-wider">{a.sub}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
